import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "generate-report-modal";

const keys = addTranslations(RESOURCE_NAME, {
    generate_report_modal_title: {
        en: "Generate report",
        fr: "Générer le rapport",
    },
    generate_report_modal_description: {
        en: "Send a request to generate a report. You will be contacted by your CSM when the report is ready.",
        fr: "Envoyer une demande pour générer un rapport. Vous serez contacté par votre CSM lorsque le rapport sera prêt.",
    },
    generate_report_modal_locale_label: {
        en: "Select in which language you want to generate the report:",
        fr: "Sélectionnez la langue dans laquelle vous souhaitez générer le rapport :",
    },
    generate_report_modal_cancel_button_label: {
        en: "Cancel",
        fr: "Annuler",
    },
    generate_report_modal_confirm_button_label: {
        en: "Send request",
        fr: "Envoyer la demande",
    },
});
export function useGenerateReportModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
